import { render, staticRenderFns } from "./family.vue?vue&type=template&id=bfff1966&scoped=true"
import script from "./family.vue?vue&type=script&lang=js"
export * from "./family.vue?vue&type=script&lang=js"
import style0 from "./family.vue?vue&type=style&index=0&id=bfff1966&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfff1966",
  null
  
)

export default component.exports